export const INT_ZERO_VALUE = 0;
export const INT_ONE_VALUE = 1;
export const EMPTY_STRING = '';
export const EMPTY_ARRAY = [];
export const AUTH_TOKEN_COOKIE = '_vc_auth_token';
// Mirrors the cookie key `@vidacamara/orange-utils` writes in setRefreshCookie/getRefreshToken; the
// package exposes neither the key nor a delete-refresh helper, so it is declared here to wipe it.
export const REFRESH_TOKEN_COOKIE = '_vc_refresh_token';
export const BFF_V1_VERSION = 'v1';

export const LOADED_MF_WITH_SINGLE_SPA = 'Microfrontend loaded as part of Single-SPA';
export const LOADED_MF_INDEPENDENTLY = 'Microfrontend loaded independently';
export const LOADED_MF_ERROR = "No container found with id 'root'";
